import { Col, Row } from "antd";

import PageTitle from "components/Menu/PageTitle";
import ProductDropdown from "components/Menu/ProductDropdown";
import ProfileDropdown from "components/Menu/ProfileDropdown";

const TopMenuBar = () => {
  return (
    <>
      <Row
        justify="space-between"
        align="middle"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
      >
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <PageTitle />
        </Col>
        <Col xs={24} sm={24} md={14} lg={14} xl={14}>
          <ProductDropdown />
        </Col>
        <Col
          xs={24}
          sm={24}
          md={4}
          lg={4}
          xl={4}
          style={{ display: "flex", justifyContent: "end" }}
        >
          <ProfileDropdown />
        </Col>
      </Row>
    </>
  );
};

export default TopMenuBar;
